import React, {
  useEffect,
  useRef,
  useState
} from 'react';

const range = length => new Array(length).fill(0).map((_, i) => ++i);
const noop = () => { };

const CodeInput = (props) => {
  const {
    autoFocus = true,
    maxLength = 6,
    onChange = noop,
    pattern = /[A-Za-z0-9]/,
    onComplete = noop,
    loading,
    onEnter
  } = props;

  const [inputValues, setInputValues] = useState(new Array(maxLength).fill(''));
  const inputs = useRef([]);

  useEffect(() => {
    if (autoFocus && inputs.current[0]) {
      inputs.current[0].focus();
    }
  }, [autoFocus]);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text').slice(0, maxLength);
    const formattedText = pastedText.split('').map(char => char.match(pattern) ? char.toUpperCase() : '').join('');
    const newInputValues = [...formattedText.padEnd(maxLength, '')];
    setInputValues(newInputValues);
    onChange(newInputValues.join(''));

    if (newInputValues.every(value => value.match(pattern))) {
      onComplete(e, newInputValues.join(''));
    }

  };

  const handleChange = (index) => (e) => {
    const { value } = e.target;
    if (!value) {
      const newInputValues = [...inputValues];
      newInputValues[index] = '';
      setInputValues(newInputValues);
      onChange(newInputValues.join(''));
      if (index > 0) {
        inputs.current[index - 1].focus();
      }
      return;
    }
    const newValue = value.length > 0 ? value[0].toUpperCase() : '';
    const newInputValues = [...inputValues];
    newInputValues[index] = newValue;
    setInputValues(newInputValues);
    onChange(newInputValues.join(''));
    const nextIndex = Math.min(maxLength - 1, index + 1);
    inputs.current[nextIndex].setSelectionRange(0, 1);
    inputs.current[nextIndex].focus();

    if (newInputValues.every(value => value.match(pattern) && value !== '')) {
      onComplete(e, newInputValues.join(''));
    }
  };

  const handleKeyPress = (index) => (e) => {
    if (e.key === 'Enter' && inputValues.join('').length === maxLength) {
      onEnter(e);
    }
  };

  return (
    <div className="inputCode">
      {range(maxLength).map((char, index) => (
        <input
          type="text"
          key={char}
          maxLength={1}
          onChange={handleChange(index)}
          onKeyPress={handleKeyPress(index)}
          onPaste={handlePaste}
          disabled={loading}
          value={inputValues[index]}
          ref={(el) => (inputs.current[index] = el)}
          className="form-control input-lg"
        />
      ))}
    </div>
  );
};

export default React.forwardRef(CodeInput);
